import {
    ActionBtn, Label, LoaderDiv, MessageError, LoaderText
} from './styles';
import { IPresenterProps } from './types';
import CustomInput from '../../../components/Input/Container';
import Spinner from '../../../components/Spinner';
import COLORS from '../../../utils/Colors';

const LoginContainer = (props: IPresenterProps) => {

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: 12 }}>
                    <Label style={{ color: COLORS.white }} htmlFor="email">Ingresa el correo asociado con tu cuenta</Label>
                </div>
                <CustomInput
                    inputType="email"
                    value={props.formData.emailForgotPassword}
                    onChange={(e: any) => props.onChange(e, 'emailForgotPassword')}
                    bgColor={COLORS.white}
                    // alertType={props.emailIcon}
                    disabled={props.emailDisabled}
                    showDeleteTextIcon={true}
                    deleteText={props.deleteInputText}
                    textColor={COLORS.hsl000100099}
                    showError={false}
                />
                {
                    props.messageError &&
                    <MessageError>Correo electrónico no encontrado.</MessageError>
                }
            </div>

            <div style={{ marginBottom: 12, marginTop: 60 }}>
                <Label style={{ color: COLORS.white, fontSize: 16 }} htmlFor="email">
                    Te enviaremos un código de verificación a tu correo electrónico para verificar que eres el propietario de esta cuenta.
                </Label>
            </div>

            {props.loaderVisible ? (
                <LoaderDiv>
                    <Spinner size={40} color="#000000" thickness={3} />
                    <LoaderText>Enviando código...</LoaderText>
                </LoaderDiv>
            ) : (
                <>
                    <ActionBtn onClick={props.actionBtn} disabled={props.sendCodeDisabledBtn}>
                        Enviar Código
                    </ActionBtn>
                    <div onClick={() => props.changeStep(1)} style={{ marginTop: 28, cursor: 'pointer' }}>
                        <p style={{ textAlign: 'center', fontSize: 18, color: COLORS.hsl000100099 }}>Cancelar</p>
                    </div>
                </>
            )}
        </>
    )
};

export default LoginContainer;
